export default __webpack_public_path__ + "static/media/README.844d630a.md";